import { Button, Group, Modal, Text } from "@mantine/core";
import { type ReactNode, useState } from "react";
import { useMessages } from "../i18n/provider";

export function ConfirmDialog({
  opened,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel,
  children,
  loading = false,
}: {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  body?: string;
  confirmLabel?: string;
  children?: ReactNode;
  loading?: boolean;
}) {
  const t = useMessages();
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title={title} size="sm">
      {body ? (
        <Text size="sm" c="dimmed">
          {body}
        </Text>
      ) : null}
      {children}
      <Group justify="flex-end" mt="lg">
        <Button variant="subtle" color="gray" onClick={onClose}>
          {t("common.cancel")}
        </Button>
        <Button color="red" onClick={() => void handleConfirm()} loading={busy || loading}>
          {confirmLabel ?? t("common.confirm")}
        </Button>
      </Group>
    </Modal>
  );
}
